export function version() {
    return "6.0.0";
}